module.exports = __webpack_public_path__ + "static/media/d6ru.06dc2bf2.pdf";